// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__BubhR","cell":"ColumnAccessor_cell__3xI36","firstCellAccent":"ColumnAccessor_firstCellAccent__Z8R3D"};